import postal from "postal"

// 这里的model是由createCustomModel返回的model
const pub = function (channel, topic, data, callback) {
    postal.publish(
        {
            channel: channel,
            topic: topic,
            data,
        },
        callback
    )
}

// 这里的model是由createCustomModel返回的model
const sub = function (channel, topic, callback) {
    const handler = postal.subscribe({
        channel: channel,
        topic: topic,
        callback,
    })
    return handler
}

const unsub = function (handler) {
    postal.unsubscribe(handler)
}

export default {
    pub,
    sub,
    unsub,
}
